import { useRef, useMemo } from 'react';
import { TDealwithKeys, TDealwithOptions } from '../types/components';

export function useInputFocus() {
  const inputRef = useRef<HTMLInputElement | null>(null);
  function changeInputRef(ref: any) {
    if (inputRef.current === null) inputRef.current = ref;
  }
  function focusInput() {
    inputRef.current?.focus();
  }

  return {
    changeInputRef,
    onFocus: focusInput,
  };
}

/**
 * 更安全的版本：使用独立依赖参数而非数组
 * @param key - 处理选项时使用的键值
 * @param dealwithOptions - 处理选项的函数
 * @param options - 原始选项数组
 * @param deeps - 依赖项数组
 */
export function useOptionsMemo({
  key,
  dealwithOptions,
  options,
  deeps = [],
}: {
  key: TDealwithKeys;
  dealwithOptions?: TDealwithOptions;
  options: any[];
  deeps?: any[];
}) {
  return useMemo(() => {
    if (!dealwithOptions) {
      return options;
    }

    return dealwithOptions(options, key);
  }, [...deeps]);
}
